import * as actionTypes from './actionTypes';

export const showAgreement=()=>({
    type:actionTypes.SHOW_AGREEMENT
})

export const hideAgreement=()=>({
    type:actionTypes.HIDE_AGREEMENT
})